import makeValueData from "../makeValueData";

function mapTo(src, dest, me, input) {
    const fondateurs = src.fondateurs || {};
    const informations = src.informations || {};
    const adresse = informations.adresse || {};
    const dureeValidite = informations.dureeValidite || {};
    const dureeRenouvellement = informations.dureeRenouvellement || {};

    dest.informations = {
        adresse: {
            codePostal: adresse.codePostal,
            commune: adresse.commune,
            adresse: adresse.adresse,
            complementAdresse: adresse.complementAdresse,
            pays: adresse.pays,
            domiciliation: adresse.domiciliation,
        },
        denomination: informations.denomination,
        numero: informations.numero,
        reference: informations.reference,
        objet: informations.objet,
        domaine: informations.domaine,
        theme: informations.theme || null,
        but: informations.but || "NON_LUCRATIF",
        cooperative: informations.cooperative,
        gouvernance: informations.gouvernance,
        utilitePublique: informations.utilitePublique,
        consentementCommunication: informations.consentementCommunication,
        stipulations: informations.stipulations,
        adresseCourriel: informations.adresseCourriel,
        adresseSite: informations.adresseSite,
        precisionStipulation: informations.stipulations ? informations.precisionStipulation : null,
        dureeValidite: {
            valeur: dureeValidite.valeur,
            unite: dureeValidite.unite || "JOUR",
        },
        dureeRenouvellement: {
            valeur: dureeRenouvellement.valeur,
            unite: dureeRenouvellement.unite || "JOUR",
        },
        finValidite: informations.finValidite,
    };

    dest.physiques = src.physiques;
    dest.morales = src.morales;
    dest.reprises = src.reprises;
    dest.fondateurs = {
        physiques: fondateurs.physiques,
        morales: fondateurs.morales,
    };

    dest.estRadiee = src.estRadiee;
    dest.estLiquidee = src.estLiquidee;

    //recopie du booleen pour le renouvellement (uniquement en modification )
    dest.renouvellementComite = src.renouvellementComite;

    //s'il y a une décision (uniquement en modification ou dissolution)
    const decision = src.decision || {};
    dest.decision = {
        type: decision.type,
    };


    const liquidation = src.liquidationAssociation || {};
    const liquidateurs = liquidation.liquidateurs || {};

    dest.liquidationAssociation = {
        commentaireLiquidation: liquidation.commentaireLiquidation,
        liquidateurs: {
            physiques: liquidateurs.physiques,
            morales: liquidateurs.morales,
            reprises: liquidateurs.reprises,
        },
    };



    const radiation = src.radiationAssociation || {};
    dest.radiationAssociation = {
        dateDissolution: radiation.dateDissolution,
        commentaireRadiation: radiation.commentaireRadiation,
        quitus: radiation.quitus,
    };

    //date à afficher en lecture
    dest.dateConstitutive = src.dateConstitutive;
    dest.dateStatuts = src.dateStatuts;
    dest.dateInscriptionJAL = src.dateInscriptionJAL;
    dest.dateDissolutionJAL = src.dateDissolutionJAL;
    dest.dateDissolution = src.dateDissolution;
    dest.dateRadiation = src.dateRadiation;

    if (input) {
        prepareInput(dest, me, src);
    }

    dest.indexMembres=[...(src.indexMembres||[])];
}

function prepareInput(dest, me) {
    var key = 1;
    dest.physiques = (dest.physiques || []).map((m, index) => ({
        index,
        prefix: `physiques[${index}]`,
        key: key++,
        statut: me.calculStatut(m, false),
        ...m,
    }));
    dest.morales = (dest.morales || []).map((m, index) => ({
        index,
        prefix: `morales[${index}]`,
        key: key++,
        statut: me.calculStatut(m, false),
        ...m,
    }));
    dest.reprises = (dest.reprises || []).map((m, index) => ({
        index,
        prefix: `reprises[${index}]`,
        key: key++,
        statut: me.calculStatut(m, false),
        ...m,
    }));

    //fondateurs
    dest.fondateurs.physiques = (dest.fondateurs.physiques || []).map(
        (m, index) => ({
            prefix: `fondateurs.physiques[${index}]`,
            key: key++,
            statut: me.calculStatutFondateurs(m, false),
            ...m,
        })
    );
    dest.fondateurs.morales = (dest.fondateurs.morales || []).map(
        (m, index) => ({
            prefix: `morales[${index}]`,
            key: key++,
            statut: me.calculStatutFondateurs(m, false),
            ...m,
        })
    );

    //liquidateurs
    if (dest.liquidationAssociation) {
        dest.liquidationAssociation.liquidateurs.physiques = (
            dest.liquidationAssociation.liquidateurs.physiques || []
        ).map((m, index) => ({
            ...m,
            prefix: `liquidateurs.physiques[${index}]`,
            key: key++,
        }));
        dest.liquidationAssociation.liquidateurs.morales = (
            dest.liquidationAssociation.liquidateurs.morales || []
        ).map((m, index) => ({
            ...m,
            prefix: `liquidateurs.morales[${index}]`,
            key: key++,
        }));
        dest.liquidationAssociation.liquidateurs.reprises = (
            dest.liquidationAssociation.liquidateurs.reprises || []
        ).map((m, index) => ({
            ...m,
            prefix: `liquidateurs.reprises[${index}]`,
            key: key++,
        }));
    }

    if (me.creation && !me.rectification) {
        prepareInputCreation(dest);
    }
}

function prepareInputCreation(dest) {
    //exclusion des membres fondateurs qui font partie des membres physiques
    const uuids = new Set();
    for (let m of [...dest.physiques, ...dest.morales]) {
        if (m.uuid) {
            uuids.add(m.uuid);
        }
    }
    //les membres fondateurs ajoutés dans l'interface non pas encore d'uuid
    const filtreUUID = m => m.uuid === null || !uuids.has(m.uuid);
    dest.fondateurs.physiques = dest.fondateurs.physiques.filter(filtreUUID);
    dest.fondateurs.morales = dest.fondateurs.morales.filter(filtreUUID);
}

export function findIndexMembres(m, indexMembres, defaultValue=-1) {
    const uuid=m.uuid;
    let out = 0;
    if(uuid) {
        out= indexMembres.findIndex(i => i.uuid===uuid);
    } else{
        const {collection, localUuid} = cleIndexageMembre(m);
        out= indexMembres.findIndex(i => i.collection===collection && i.localUuid===localUuid);
    }
    return out < 0 ? defaultValue : out;
}

export function  cleIndexageMembre(membre) {
    if(membre.uuid) {
      return {uuid: membre.uuid};
    } else {
      return {collection: membre.type+"s", localUuid: membre.localUuid};
    }
  }

export default function () {
    return {
        mixins: [makeValueData(mapTo)],
        computed: {
            membres() {
                const membres = [];
                for (let p of this.physiques) {
                    membres.push({
                        type: "physique",
                        ...p,
                    });
                }

                for (let m of this.morales) {
                    membres.push({
                        type: "morale",
                        ...m,
                    });
                }

                for (let r of this.reprises) {
                    membres.push({
                        type: "reprise",
                        ...r,
                    });
                }
                const indexMembres = this.indexMembres;
                return membres.sort((l,r) => findIndexMembres(l,indexMembres,10000)-findIndexMembres(r, indexMembres, 10000));
            },
            membresFondateurs() {
                const membres = [];
                for (let p of this.fondateurs.physiques) {
                    membres.push({
                        type: "physique",
                        ...p,
                    });
                }

                for (let m of this.fondateurs.morales) {
                    membres.push({
                        type: "morale",
                        ...m,
                    });
                }

                return membres;
            },
            liquidateurs() {
                const membres = [];
                if (this.liquidationAssociation) {
                    const liquidateurs = this.liquidationAssociation.liquidateurs;
                    for (let p of liquidateurs.physiques) {
                        membres.push({
                            type: "physique",
                            ...p,
                        });
                    }

                    for (let m of liquidateurs.morales) {
                        membres.push({
                            type: "morale",
                            ...m,
                        });
                    }

                    for (let r of liquidateurs.reprises) {
                        membres.push({
                            type: "reprise",
                            ...r,
                        });
                    }
                }
                return membres;
            },
        },
        methods: {
            calculStatutFondateurs(membre, undo) {
                const matchUUID = m => m.uuid === membre.uuid;
                const fondateurs = this.modifications?.fondateurs;
                let statut = null;
                // trouver le statut de la personne
                if (
                    fondateurs?.physiques?.ajoutes?.find(matchUUID) ||
                    fondateurs?.morales?.ajoutes?.find(matchUUID)
                ) {
                    statut = "ajout";
                } else if (
                    !undo &&
                    (fondateurs?.physiques?.supprimes?.find(matchUUID) ||
                        fondateurs?.morales?.supprimes?.find(matchUUID))

                ) {
                    statut = "supprime";
                } else if (
                    fondateurs?.physiques?.modifies?.find(matchUUID) ||
                    fondateurs?.morales?.modifies?.find(matchUUID)
                ) {
                    statut = "modifie";
                }

                return statut;
            },
            calculStatut(membre, undo) {
                const matchUUID = m => m.uuid === membre.uuid;
                let statut = null;
                const membres = this.modifications?.membres;
                const membresConflits = this.conflits?.membres;

                // trouver le statut de la personne
                if (
                    membres?.physiques?.ajoutes?.find(matchUUID) ||
                    membres?.morales?.ajoutes?.find(matchUUID) ||
                    membres?.reprises?.ajoutes?.find(matchUUID)
                ) {
                    statut = "ajout";
                } else if (
                    !undo && (
                        membres?.physiques?.supprimes?.find(matchUUID) ||
                        membres?.morales?.supprimes?.find(matchUUID) ||
                        membres?.reprises?.supprimes?.find(matchUUID)
                    )
                ) {
                    statut = "supprime";
                } else if (
                    membresConflits?.physiques?.conflits?.find(matchUUID) ||
                    membresConflits?.morales?.conflits?.find(matchUUID) ||
                    membresConflits?.reprises?.conflits?.find(matchUUID)
                ) {
                    statut = "conflit";
                } else if (
                    membres?.physiques?.modifies?.find(matchUUID) ||
                    membres?.morales?.modifies?.find(matchUUID) ||
                    membres?.reprises?.modifies?.find(matchUUID)
                ) {
                    statut = "modifie";
                }

                return statut;
            },
            themeChanged(themes) {
                if (themes?.length === 0) {
                    this.informations.theme = null;
                }
                this.changed();
            },
        },
    };
}
